<template>
  <vx-card  :title="$t('sections.accounting.dataSection.generalInformation')" refresh-content-action @refresh="handleRefreshClick">
    <template v-if="visible">
      <vs-tabs>
        <vs-tab :label="$t('sections.accounting.dataSection.contractInformation')">
          <contract-information/>
        </vs-tab>
        <vs-tab :label="$t('sections.accounting.dataSection.suretyInformation')">
          <surety-information :manage="manage"/>
        </vs-tab>
        <vs-tab :label="$t('sections.accounting.dataSection.loanInformation')">
          <loan-information :manage="manage"/>
        </vs-tab>
        <vs-tab :label="$t('sections.accounting.dataSection.loanPlanInformation')">
          <loan-plan-information :manage="manage"/>
        </vs-tab>
        <vs-tab :label="$t('sections.accounting.dataSection.feeInformation')">
          <fee-information :manage="manage"/>
        </vs-tab>
        <vs-tab :label="$t('sections.accounting.dataSection.paymentRoundInformation')">
          <payment-round-information :manage="manage"/>
        </vs-tab>
        <vs-tab :label="$t('sections.accounting.dataSection.paymentInformation')">
          <payment-information :manage="manage" :payment-extra="true"/>
        </vs-tab>
        <vs-tab :label="$t('sections.accounting.dataSection.interestRateInformation')">
          <interest-rate-information :manage="manage"/>
        </vs-tab>
        <vs-tab :label="$t('sections.accounting.dataSection.callHistoryInformation')">
          <call-history-information/>
        </vs-tab>
        <vs-tab :label="$t('sections.accounting.dataSection.sendSmsHistoryInformation')">
          <send-sms-history-information/>
        </vs-tab>
        <vs-tab :label="$t('sections.accounting.dataSection.sendDocHistoryInformation')">
          <send-doc-history-information/>
        </vs-tab>
        <vs-tab :label="$t('sections.accounting.dataSection.lawsuitHistoryInformation')">
          <lawsuit-history-information/>
        </vs-tab>
      </vs-tabs>
    </template>
  </vx-card>

</template>

<script>
  /* eslint-disable no-unused-vars */
  const _ = require('lodash');
  import {createNamespacedHelpers} from 'vuex'
  const { mapActions: mapAccountingActions, mapState: mapAccountingState} = createNamespacedHelpers('Accounting');
  import ContractInformation from './ContractHeaderDetail/ContractInformation'
  import SuretyInformation from './ContractHeaderDetail/SuretyInformation'
  import LoanInformation from './ContractHeaderDetail/LoanInformation'
  import LoanPlanInformation from './ContractHeaderDetail/LoanPlanInformation'
  import FeeInformation from './ContractHeaderDetail/FeeInformation'
  import InterestRateInformation from './ContractHeaderDetail/InterestRateInformation'
  import PaymentRoundInformation from './ContractHeaderDetail/PaymentRoundInformation'
  import PaymentInformation from './ContractHeaderDetail/PaymentInformation'
  import CallHistoryInformation from './ContractHeaderDetail/CallHistoryInformation'
  import LawsuitHistoryInformation from './ContractHeaderDetail/LawsuitHistoryInformation'
  import SendSmsHistoryInformation from './ContractHeaderDetail/SendSmsHistoryInformation'
  import SendDocHistoryInformation from './ContractHeaderDetail/SendDocHistoryInformation'

  export default {
    name: "ContractHeaderDetail",
    props: ['manage'],
    components: {
      ContractInformation,
      SuretyInformation,
      LoanInformation,
      LoanPlanInformation,
      FeeInformation,
      PaymentRoundInformation,
      PaymentInformation,
      InterestRateInformation,
      CallHistoryInformation,
      LawsuitHistoryInformation,
      SendSmsHistoryInformation,
      SendDocHistoryInformation,
    },
    computed:{
      ...mapAccountingState([
        'status',
        'contract',
      ]),
      visible(){
        return !_.isEmpty(this.contract);
      },
    },
    methods: {
      ...mapAccountingActions([
        'getContractTransactionManageRefresh',
      ]),
      async handleRefreshClick(card) {
        const vm = this
        const { getContractTransactionManageRefresh } = vm
        await getContractTransactionManageRefresh({form: {id: vm.contract.id}})
        card.removeRefreshAnimation(500)
      },
    },
  }
</script>
